import React, { useState } from 'react';

const CreditTopup = ({ user }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const starterCredits = 150000;

  const creditPackages = [
    {
      id: 'starter',
      name: 'Starter',
      price: '$10',
      priceInCents: 1000,
      credits: '150,000',
      charactersLabel: '150,000 Characters',
      description: 'Great for getting started',
      icon: '⭐',
      stripeLink: process.env.REACT_APP_STRIPE_PAYMENT_LINK_STARTER,
      bonus: null
    },
    {
      id: 'creator',
      name: 'Creator',
      price: '$20',
      priceInCents: 2000,
      credits: '400,000',
      charactersLabel: '400,000 Characters',
      description: 'Most popular choice',
      icon: '🎬',
      stripeLink: process.env.REACT_APP_STRIPE_PAYMENT_LINK_CREATOR,
      bonus: Math.round(((400000 - starterCredits * 2) / (starterCredits * 2)) * 100)
    },
    {
      id: 'professional',
      name: 'Professional',
      price: '$50',
      priceInCents: 5000,
      credits: '1.1M',
      charactersLabel: '1.1 Million Characters',
      description: 'For power users',
      icon: '⚡',
      stripeLink: process.env.REACT_APP_STRIPE_PAYMENT_LINK_PROFESSIONAL,
      bonus: Math.round(((1100000 - starterCredits * 5) / (starterCredits * 5)) * 100)
    }
  ];

  const handleSelectPlan = (plan) => {
    if (!plan.stripeLink) {
      console.error('Stripe payment link not configured for this plan');
      return;
    }
    setSelectedPlan(plan.id);
    setIsLoading(true);
    // Redirect to Stripe payment link with prefilled email
    const separator = plan.stripeLink.includes('?') ? '&' : '?';
    const checkoutUrl = `${plan.stripeLink}${separator}prefilled_email=${encodeURIComponent(user.email)}`;
    window.location.href = checkoutUrl;
  };

  if (!user) {
    return (
      <div className="auth-required">
        <p>Please sign in to add credits</p>
      </div>
    );
  }

  return (
    <div className="content-wrapper">
      <div className="content-inner">
        <div className="card-container">
          <div style={{ marginBottom: '32px' }}>
            <h2 className="section-title">💳 Add Credits</h2>
            <p className="subtitle">Choose a package to purchase credits</p>
            <p style={{ marginTop: '16px', fontSize: '14px', color: '#ff9800' }}>
              ⚠️ Important: Please use the same email address (<strong>{user.email}</strong>) during checkout to ensure credits are added to your account.
            </p>
          </div>

          {/* Packages Grid */}
          <div className="credit-packages-grid">
            {creditPackages.map((plan) => (
              <div
                key={plan.id}
                className={`credit-package-card ${selectedPlan === plan.id ? 'selected' : ''}`}
              >
                {plan.bonus !== null && (
                  <div className="bonus-badge">
                    <span>+{plan.bonus}% Bonus</span>
                  </div>
                )}
                <div className="package-icon">{plan.icon}</div>
                <h3 className="package-name">{plan.name}</h3>
                <div className="package-description">{plan.description}</div>

                <div className="package-price">{plan.price}</div>
                <div className="package-credits">{plan.charactersLabel}</div>

                <button
                  className="btn btn-primary btn-block"
                  onClick={() => handleSelectPlan(plan)}
                  disabled={isLoading && selectedPlan === plan.id}
                >
                  {isLoading && selectedPlan === plan.id ? 'Processing...' : 'Buy'}
                </button>

                <div className="package-benefits">
                  <small>✓ Lifetime credits</small>
                  <small>✓ API access included</small>
                </div>
              </div>
            ))}
          </div>

          {/* Info Section */}
          <div className="credit-topup-info" style={{ marginTop: '32px' }}>
            <p>💡 Credits never expire and work everywhere - web app and API!</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreditTopup;
